/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Box, styled, Typography, Select, MenuItem } from '@mui/material';
import { useState } from 'react';
import { AddAssemblyStock } from './AddAssemblyStock';
import { AddPieceStock } from './AddPieceStock';
import { AddUnderAssemblyStock } from './AddUnderAssemblyStock';
import { AddSteleStock } from './AddSteleStock';

type StockType = 'piece' | 'assembly' | 'under-assembly' | 'stele';
export const AddStock = () => {
  const [selectedType, setSelectedType] = useState<StockType>('piece');

  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Ajouter du stock
      </Typography>

      <Select value={selectedType} onChange={(e) => setSelectedType(e.target.value as StockType)}>
        <MenuItem value="piece">Pièce</MenuItem>
        <MenuItem value="stele">Stele</MenuItem>
        <MenuItem value="assembly">Assemblage</MenuItem>
        {/* <MenuItem value="under-assembly">Sous assemblage</MenuItem> */}
      </Select>

      {selectedType === 'piece' && <AddPieceStock />}
      {selectedType === 'stele' && <AddSteleStock />}
      {selectedType === 'assembly' && <AddAssemblyStock />}
      {selectedType === 'under-assembly' && <AddUnderAssemblyStock />}
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: '20px',
});

const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

const Row = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
});
